// extracted by mini-css-extract-plugin
export var gameLink = "game-link-module--gameLink--75e63";
export var image = "game-link-module--image--ca3c3";
export var missingImage = "game-link-module--missingImage--b4667";
export var overlay = "game-link-module--overlay--b6bdd";
export var text = "game-link-module--text--55780";